export default __webpack_public_path__ + "static/media/SG18.42c3a674.png";